export default "__VITE_ASSET__Bw4NvVEP__"